import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header';
import { FaSearch } from "react-icons/fa";
import MaterialTable from '../../Components/Table/MaterialTable';
import { tableEye } from '../../common/Assets/imgs';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../../Services/Constant';
import { get, put } from '../../Services/ApiHandler';
import toast from 'react-hot-toast';

const Roles = () => {

    const navigation = useNavigate();

    const [adminList,setAdminList] =useState([])
    const [search,setSearch]=useState("");
    const [pagination, setPagination] = useState(1);
    const [loader, setLoader] = useState(false);

    // const adminList = [
    //     {
    //         sno: "01",
    //         vehicleType: "cargo Truck-20FT",
    //         maxVolume: "30 TON",
    //         price: "150",
    //     },
    //     {
    //         sno: "02",
    //         vehicleType: "cargo Truck-20FT",
    //         maxVolume: "30 TON",
    //         price: "150",
    //     },
    //     {
    //         sno: "03",
    //         vehicleType: "cargo Truck-20FT",
    //         maxVolume: "30 TON",
    //         price: "150",
    //     },
    // ];

    
    const pageSize = 10;
    
    const columns = [
        {
            header: "S.No",
//   accessorFn: (row, index) => index + 1,
     accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
  id: "serial_no",
        },
        {
            accessorKey: "type",
            header: "Vehicle Type",
        },
        {
            accessorKey: "max_ton",
            header: "Max Volume",
        },
        {
            accessorKey: "price",
            header: "Price (KM)",
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return (
                    // <div className={`${value === "Active" ? 'statusactive' : 'statusdeactive'}`} >
                    <span className='text-success'>
                        {`₹${value}`}
                    </span>
                    // </div>
                );
            },
        },
        {
            accessorKey:"status",
            header:"Status",
            Cell:({cell,row}) => {
                return (
                    // <button 
                   <span className={`${cell.getValue() ? "status-active" : "status-inactive"}`}
                    onClick={()=>statusChanger(row?.original?.id,row?.original?.status)}>
                  {cell.getValue() ? "Active" : "Deactive"}
                    </span>
                    // {/* </button> */}
                )
            }

        },
        {
            id: "action", // ✅ important when no accessorKey
            header: "Action",
            Cell: ({ row }) => {
                console.log('Row Data',row.original);
                console.log('Row ID',row.original.id);
                
                return (

                
                <div onClick={() => {
                    navigation('/add-vehicle',{
                    state: {
                        data:row.original,
                        id:row.original.id,
                        type:'view'
                    }  
                })
            
                }}
                >
                    <img src={tableEye} alt="" className='tableeye' />
                </div>
            )
        }
        },
    ];

    const getList =async (src,page) =>{
     try {
        setLoader(true);
        const response = await get(`${URLS.VEHICLE_LIST}?search=${src}&page=${page}`) ;
        console.log('res',response);
        if(response?.status === "success"){
        setAdminList(response?.data)
        setLoader(false);
        }
     }
     catch(error){
        console.log('err',error);
        setLoader(false);
     }
    };

    useEffect(()=>{
      getList(search,pagination);
    },[search,pagination])

    // const handleSearch = async()=>{
    //    getList(search);
    // }

    const statusChanger =(id,currentstatus) =>{
     put(`${URLS.VEHICLE_STATUS}${id}/`,{
        status:currentstatus === true ? false : true,
     })
     .then((res)=>{
        if(res?.status === "success"){
            toast.success(res?.message);
            getList(search,pagination);
        }
     })
     .catch((err)=>{
        console.log("err",err);
     })
    }



    return (
        <div>
            <Header title={"Vehicle Master"} />

            <div className="container-fluid main-container">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    {/* LEFT TITLE */}
                    <h3 className="m-0 fw-bold fs-5 text-black">Vehicle Master</h3>

                    {/* RIGHT SECTION */}
                    <div className="d-flex align-items-center gap-3">

                        {/* SEARCH BOX */}
                        <div className="search-box d-flex align-items-center px-3"
                        >
                            <input
                                type="text"
                                placeholder="Search"
                                className="border-0 outline-none bg-transparent"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <div className="ms-2 searchdote" >|</div>
                            <FaSearch color='#7A52AB' className="ms-1" />
                        </div>

                        {/* ADD BUTTON */}
                        <button onClick={() => navigation('/add-vehicle',
                            {
                                state: {
                                    type: "add"
                                }
                            }
                        )} style={{ backgroundColor: "#F98425" }} className="btn text-white fw-semibold px-4 py-2">
                            + Add Vehicle
                        </button>

                    </div>

                </div>
                <MaterialTable columns={columns} 
                data={adminList || []}
                 pagination={pagination}
                 setPagination={setPagination}
                 loading={loader}  />
            </div>
        </div>
    );
};

export default Roles;
